import { render, staticRenderFns } from "./bajas.view.vue?vue&type=template&id=1129ea60"
import script from "./bajas.view.vue?vue&type=script&lang=js"
export * from "./bajas.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports